/**
 * Ermittelt die Basis-URL des Backend-Servers in Abhängigkeit der aktuellen Laufzeitumgebung
 * (z. B. lokaler Web-Dev-Server, Electron-Desktop-Client oder Capacitor-Mobil-App).
 * 
 * @returns {string} Die vollständige URL zum Backend-API-Server
 */
export const getBackendUrl = () => {
  let url = 'http://localhost:8080';

  const isElectron = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().includes('electron');

  if (window.ENV && window.ENV.BACKEND_URL) {
    url = window.ENV.BACKEND_URL;
  } else if (window.Capacitor && window.Capacitor.getPlatform() !== 'web') {
    url = 'https://backend.appentwicklung.maryu.eu';
  } else if (isElectron) {
    // Prüfen, ob die Desktop-App als Installer verpackt läuft (Produktion) oder im Entwicklungsmodus.
    const isPackaged = window.location.href.includes('app.asar') || 
                       window.location.href.includes('/resources/') ||
                       (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production');
    
    if (isPackaged) {
      url = 'https://backend.appentwicklung.maryu.eu';
    } else {
      url = 'http://localhost:8080';
    }
    console.log('[Electron] Backend URL:', url, 'Packaged:', isPackaged);
  } else if (window.location.hostname === 'localhost' && window.Capacitor) {
    url = 'https://backend.appentwicklung.maryu.eu';
  }

  if (window.Capacitor) {
    console.log('[Capacitor] Backend URL:', url, 'Platform:', window.Capacitor.getPlatform());
  }

  return url;
};
